import { z } from "zod";

export const create = z.object({
  name: z.string().min(1, "Required"),
  code: z.string().min(1, "Required"),
  manufacturer: z.string().nullish(),
  price: z.coerce.number().nullish().prefault(0),
  kitName: z.string().nullish(),
  notes: z.string().nullish(),
  reportDisclaimer: z.string().nullish(),
  selectable: z.boolean().prefault(false),
  printLabels: z.boolean().prefault(false),
  printLabelsWithReflex: z.boolean().prefault(false),
  shouldReportReflex: z.boolean().prefault(false),
  type: z.enum(["SEROLOGY", "CLINICAL", "HLA", "MICROBIOLOGY"]),
  refRangeValue: z.string().nullish(),
  referenceOrgId: z.number().nullish(),
  instrumentId: z.number().nullish(),
  invoiceOverrideId: z.number().nullish(),
  preferredTubeId: z.number().nullish(),
  testSpecGroupId: z.number().nullish(),
  disableReport: z.boolean().prefault(false),
  disableTestRun: z.boolean().prefault(false),
  alwaysShowHeader: z.boolean().prefault(false),
  processTemplateVersionId: z.number().nullish(),
  sampleAssignmentType: z
    .enum(["AUTO_ASSIGN", "MANUAL_ASSIGN"])
    .prefault("AUTO_ASSIGN"),
  billingMode: z
    .enum(["PER_SAMPLE", "PER_ACCESSION"])
    .prefault("PER_ACCESSION"),
  containerPreferences: z
    .object({
      containerId: z.number(),
      priority: z.number(),
    })
    .array()
    .nullish(),
});

export const update = create.extend({ id: z.number() });
